import { bootstrapMontageApp } from '@core/bootstrap';
import { TPortalType } from '@core/enums/portal-type.enum';

import { TECH_APP } from './app/app';
import { AppComponent } from './app/app.component';

bootstrapMontageApp(AppComponent, TECH_APP, TPortalType.TechPortal, true);
